














import { Vue, Component } from 'vue-property-decorator';
import CamaraEventBus from '@/pantallas/Camaras/CamaraEventBus';
import CalendarioHistorico from '@/pantallas/Camaras/CalendarioHistorico/CalendarioHistorico.vue';

@Component({
  components: { CalendarioHistorico },
})
export default class CalendarioHistoricoPantalla extends Vue {}
